import React, {useEffect, useState} from "react";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import {useDataWithRoute, useTitleFromComponent} from "../../../utils/hooks";
import Grid from "../../../components/Grid";
import {Card} from "reactstrap";
import {useVsiAppContext} from "../../../stores/VsiApp";
import {databaseInstancesDefs} from "../../../utils/gridColumnDefs/databases/databaseInstancesDefs";
import {useNavigate} from "react-router-dom";

export default function DatabaseInstances({title}) {
    useTitleFromComponent(title);
    let navigate = useNavigate();

    const { theme, client, periodId } = useVsiAppContext();
    const [gridData, setGridData] = useState([]);
    const [data, {isLoading}] = useDataWithRoute(`/api/v6/report/database_instances_proc?client_id=${client.clientId}&period_id=${periodId}`);

    useEffect(() => {
        if (data?.recordsets?.[0]?.length) {
            const parsedData = data?.recordsets?.[0].map(item => ({
                ...item,
                total_tablespaces: parseInt(item?.total_tablespaces || 0, 10),
                total_tablespaces_gb: parseFloat(item?.total_tablespaces_gb || 0, 10),
                total_bytes: parseInt(item?.total_bytes || 0, 10),
                total_blocks: parseInt(item?.total_blocks || 0, 10),
                increment: parseFloat(item?.increment || 0, 10),
                user_bytes: parseInt(item?.user_bytes || 0, 10),
                user_blocks: parseInt(item?.user_blocks || 0, 10),
            }));
            setGridData(parsedData)
        }
    }, [data]);

    const onRowDoubleClick = (e) => {
        navigate(`/reports/database/server/database-instance-detail?instance_name=${encodeURI(e.data.instance_name)}&device_type=${encodeURI(e.data.device_type_code)}`)
    }

    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>Database All Instances</VsiH4>
            <VsiBubble>
                <Grid addStyle
                      gridText={'Double click a server to see more details'}
                      data={gridData}
                      isLoading={isLoading}
                      rowDoubleClicked={onRowDoubleClick}
                      columnDefs={databaseInstancesDefs}/>
            </VsiBubble>
        </Card>
    );
}
